// eslint:disable max-line-length
import { validationHighlights } from 'app/area/administration/shared/helpers';
import { CodetableTranslation } from 'app/area/codetable/constants';
import {
  shouldRenderDetails, shouldRenderTranslations, shouldRenderVisibility
} from 'app/area/codetable/item/codetable-item-form-render-helpers';
import { ScreenField, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { CodeEditSectionType, MetroLineConfigurationPayload } from 'app/area/codetable/item/types';
import { CodeFieldFlagWireKey, CodeFieldWireKey, CodetableFeature } from 'app/area/codetable/types-store';
import { Configuration } from 'app/components/metro-line/types';
import { routeConstants } from 'app/routes/route-constants';

export const scalarValuesConfiguration = ({ metadata, breadcrumbs, codeId, actionType, validationErrors,
  scalarValuesRef, detailsSectionRef, visibilitySectionRef, translationsSectionRef, riskMatrixConfigurationRef
}: MetroLineConfigurationPayload):
  Configuration<CodeEditSectionType>[] => ([
    {
      section: CodeEditSectionType.RiskMatrixReminderSection,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(
        breadcrumbs, codeId, CodeEditSectionType.RiskMatrixReminderSection, actionType
      ),
      label: (translation: CodetableTranslation) => translation.risk_matrix_configuration,
      ref: riskMatrixConfigurationRef,
      isValid: true
    },
    {
      section: CodeEditSectionType.Details,
      visible: shouldRenderDetails(metadata),
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Details, actionType),
      label: (translation: CodetableTranslation) => translation.details,
      ref: detailsSectionRef,
      isValid: validationHighlights([CodeFieldFlagWireKey.scoreCalcWeight,
      CodetableFeature.parent, CodetableFeature.node, CodetableFeature.category, CodetableFeature.icon, CodeFieldWireKey.colourCode,
      ScreenPicker.likelihood, ScreenPicker.recurrence, ScreenPicker.severity, ScreenField.scoreCalcWeight,
      ScreenField.companyRegisterId, ScreenField.likelihoodLevel, CodeFieldFlagWireKey.sequence,
      ScreenField.recurrenceLevel], validationErrors)
    },
    {
      section: CodeEditSectionType.ScalarValues,
      visible: true,
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.ScalarValues, actionType),
      label: (translation: CodetableTranslation) => translation.scalar_values,
      ref: scalarValuesRef,
      isValid: validationHighlights([ScreenField.low, ScreenField.mid, ScreenField.high, ScreenPicker.uom], validationErrors)
    },
    {
      section: CodeEditSectionType.Visibility,
      visible: shouldRenderVisibility(metadata),
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Visibility, actionType),
      label: (translation: CodetableTranslation) => translation.visibility,
      ref: visibilitySectionRef,
      isValid: validationHighlights([CodeFieldWireKey.application, CodeFieldWireKey.subset], validationErrors)
    },
    {
      section: CodeEditSectionType.Translations,
      visible: shouldRenderTranslations(metadata),
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Translations, actionType),
      iconUrl: '/i/case-sections/actions.svg',
      label: (translation: CodetableTranslation) => translation.descriptions_and_translations,
      ref: translationsSectionRef,
      isValid: validationHighlights(['language'], validationErrors)
    }
  ]);
